// extracted by mini-css-extract-plugin
module.exports = {"error":"language_error_1tG6x","languageBox":"language_languageBox_1QZN0","left":"language_left_1MuJn","right":"language_right_jeHPB","successColor":"language_successColor_2YqLW"};